import { LOCAL_STORAGE_NAME_TOKEN } from '../../constants/storage'
import { getTokenCookie, removeTokenCookie } from '../../utils/cookie'
import { getStorageItem, setStorageItem } from '../../utils/storage'

export function useApplyCookieToken() {
  const token = getTokenCookie()

  if (token) {
    if (!getStorageItem(LOCAL_STORAGE_NAME_TOKEN)) {
      setStorageItem(LOCAL_STORAGE_NAME_TOKEN, token)
    }

    removeTokenCookie()
  }
}
